var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPaymentDiner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 86,
    viewBox: "0 0 135 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.076 -0.00256348H0.380859V85.6994H134.076V-0.00256348Z",
    fill: "#0079BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.212 43.0969C103.212 26.0568 88.9888 14.2788 73.4047 14.2839H59.9937C44.224 14.2783 31.2441 26.0602 31.2441 43.0969C31.2441 58.6827 44.224 71.4883 59.9937 71.4129H73.4047C88.9877 71.4876 103.212 58.6786 103.212 43.0969Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0777 16.6973C45.6677 16.7019 33.9917 28.4055 33.9883 42.8501C33.9917 57.2922 45.6684 68.9943 60.0777 68.9995C74.491 68.9948 86.1705 57.2921 86.1722 42.8501C86.1703 28.4055 74.4912 16.7024 60.0777 16.6973Z",
    fill: "#0079BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5859 42.7799C43.5996 35.7213 47.9989 29.7023 54.2027 27.3107V58.2457C47.9989 55.855 43.5995 49.8392 43.5859 42.7799ZM66.0399 58.2532V27.3097C72.2459 29.6956 76.6522 35.7183 76.6633 42.7801C76.6522 49.844 72.2459 55.862 66.0399 58.2526V58.2532Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPaymentDiner);
export default __webpack_public_path__ + "static/media/ico_payment_diner.480052be44397bcc467fa0e1deafd7cb.svg";
export { ForwardRef as ReactComponent };